import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import {
  EmailField,
  FormTextField,
  TermsAndConditionsField,
  TimeZoneField,
} from '../../../../Form';
import { InvitationStore } from '../../InvitationStore';
import { LockedAccessState } from '../../InvitationStore/Types';
import LockedUserMessage from './LockedUserMessage';

interface Props {
  store: InvitationStore;
  state: LockedAccessState;
}

function ProfileForm({ store, state }: Props) {
  const submit = (store: InvitationStore) => (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    store.registering();
  };

  return (
    <>
      <LockedUserMessage state={store.state} />
      <form
        data-testid="registration-form"
        data-intercom-target="shared-enrollment-registration-form"
        className="flex w-[600px] max-w-full flex-col gap-4 md:gap-6"
        onSubmit={submit(store)}
      >
        <div className="flex sm:gap-6">
          <div className="basis-full sm:basis-1/2">
            <EmailField
              data-testid="registration-form_email-text-field"
              data-intercom-target="registration-email-field"
              value={state.emailAddress}
              disabled={!store.emailInputEnabled}
            />
          </div>
          <div className="sm:basis-1/2" />
        </div>
        <div className="flex flex-col gap-4 sm:flex-row md:gap-6">
          <FormTextField
            data-testid="registration-form_first-name-text-field"
            data-intercom-target="registration-first-name-field"
            label={<T kind="First Name" />}
            value={state.firstName}
            disabled={!store.formInputsEnabled}
            onChange={store.setFirstName}
          />
          <FormTextField
            data-testid="registration-form_last-name-text-field"
            data-intercom-target="registration-last-name-field"
            label={<T kind="Last Name" />}
            value={state.lastName}
            disabled={!store.formInputsEnabled}
            onChange={store.setLastName}
          />
        </div>
        {state.timeZoneOptions.length > 0 && (
          <TimeZoneField
            value={state.timeZone}
            onChange={store.setTimeZone}
            options={state.timeZoneOptions}
            disabled={!store.formInputsEnabled}
          />
        )}
        <TermsAndConditionsField
          checked={state.termsAccepted}
          disabled={!store.formInputsEnabled}
          onChange={store.setTermsAcceptance}
        />
        <div className="mt-6">
          <Button
            data-testid="registration-form_confirm-registration-button"
            data-intercom-target="confirm-registration-button"
            type="submit"
            color="success"
            radius="sm"
            size="lg"
            disabled={store.formDisabled}
          >
            <T kind="Confirm Registration" />
          </Button>
        </div>
      </form>
    </>
  );
}

export default observer(ProfileForm);
